import type { SVGProps } from 'react';

const SvgClassPolice = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_1234_44029)'>
      <path
        d='M17.1211 1H6.8789C5.82278 1 4.94868 1.82117 4.8828 2.87524L4 17H20L19.1172 2.87524C19.0513 1.82117 18.1772 1 17.1211 1Z'
        fill='#FF4040'
      />
      <path
        d='M17.1211 0.5C18.4412 0.5 19.5337 1.52631 19.6162 2.84375L20.499 16.9688L19.501 17.0312L18.6182 2.90625C18.5687 2.11579 17.9131 1.5 17.1211 1.5H6.87891C6.08687 1.5 5.43133 2.11579 5.38184 2.90625L4.49902 17.0312L3.50098 16.9688L4.38379 2.84375C4.46629 1.52631 5.55885 0.5 6.87891 0.5H17.1211Z'
        fill='currentColor'
      />
      <path d='M13 10V17H11V10H13Z' fill='#696D74' />
      <path d='M13.5 9.5V17.5H10.5V9.5H13.5ZM11.5 16.5H12.5V10.5H11.5V16.5Z' fill='currentColor' />
      <path
        d='M14.5 9.5C14.5 10.8807 13.3807 12 12 12C10.6193 12 9.5 10.8807 9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5Z'
        fill='#F0C419'
      />
      <path
        d='M14 9.5C14 8.39543 13.1046 7.5 12 7.5C10.8954 7.5 10 8.39543 10 9.5C10 10.6046 10.8954 11.5 12 11.5C13.1046 11.5 14 10.6046 14 9.5ZM15 9.5C15 11.1569 13.6569 12.5 12 12.5C10.3431 12.5 9 11.1569 9 9.5C9 7.84315 10.3431 6.5 12 6.5C13.6569 6.5 15 7.84315 15 9.5Z'
        fill='currentColor'
      />
      <path
        d='M1 18C1 17.4477 1.44772 17 2 17H22C22.5523 17 23 17.4477 23 18V22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22V18Z'
        fill='#696D74'
      />
      <path
        d='M22.5 18C22.5 17.7239 22.2761 17.5 22 17.5H2C1.72386 17.5 1.5 17.7239 1.5 18V22C1.5 22.2761 1.72386 22.5 2 22.5H22C22.2761 22.5 22.5 22.2761 22.5 22V18ZM23.5 22C23.5 22.8284 22.8284 23.5 22 23.5H2C1.17157 23.5 0.5 22.8284 0.5 22V18C0.5 17.1716 1.17157 16.5 2 16.5H22C22.8284 16.5 23.5 17.1716 23.5 18V22Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1234_44029'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassPolice;
